export default "__VITE_ASSET__b4984d00__"